import { gsap, CSSPlugin } from 'gsap'
gsap.registerPlugin(CSSPlugin)

class Animation {
    timeline = gsap.timeline();
}
export default new Animation()
